import type { Reducer } from 'react'

import type { Action, State } from './types'

export interface InitialStateProps {
  savedCategory?: State['category']
  prefilledInput: string | null
}

export const getInitialState = ({ savedCategory, prefilledInput }: InitialStateProps): State => ({
  search:
    savedCategory?.businessTerm?.displayNameOverride ||
    savedCategory?.businessTerm?.displayName ||
    prefilledInput ||
    undefined,
  searchSource: 'unknown',
  categoriesLoading: false,
  category: savedCategory,
  categories: [],
})

export const reducer: Reducer<State, Action> = (state, action) => {
  if (action.type === 'loadCategoriesStart') {
    return {
      ...state,
      categoriesLoading: true,
    }
  }
  if (action.type === 'loadCategoriesSuccess') {
    return { ...state, categoriesLoading: false, categories: action.categories }
  }
  if (action.type === 'selectSuggestion') {
    return {
      ...state,
      search: action.suggestion,
      searchSource: 'suggestions',
      category: undefined,
      categories: [],
    }
  }
  if (action.type === 'changeSearch') {
    return {
      ...state,
      search: action.search,
      searchSource: 'input',
      category: state.category?.businessTerm?.displayName === action.search ? state.category : undefined,
    }
  }
  if (action.type === 'selectCategory') {
    return {
      ...state,
      category: action.category,
      search: action.category.businessTerm?.displayName,
    }
  }
  if (action.type === 'matchCategory') {
    return {
      ...state,
      category: action.category,
    }
  }
  if (action.type === 'buttonClicked') {
    return {
      ...state,
      clickedButton: action.clickedButton,
    }
  }
  return state as typeof action
}
